import { jsx as _jsx } from "react/jsx-runtime";
export function InputAddon({ icon, onClick }) {
    return (_jsx("div", { className: "input-group-btn", children: _jsx("button", { type: "button", className: "btn btn-success", onClick: onClick, children: _jsx("i", { className: `fa fa-${icon}` }) }) }));
}
